import React, { useState, useEffect } from "react";
//Styled Components
import styled from "styled-components";
//useHistory
import { useHistory } from "react-router-dom";
//Data
import { MovieState } from "../movieState";
//Animations
import { motion } from "framer-motion";
import { pageAnimation } from "./animation";

const MovieDetail = () => {
  const history = useHistory();
  const url = history.location.pathname;

  const [movies, setMovies] = useState(MovieState);
  const [movie, setMovie] = useState(null);

  //UseEffect
  useEffect(() => {
    const currentMovie = movies.filter((stateMovie) => stateMovie.url === url);
    setMovie(currentMovie[0]);
  }, [movies, url]);

  return (
    <>
      {movie && (
        <Details
          variants={pageAnimation}
          initial="hidden"
          animate="show"
          exit="exit"
        >
          <HeadLine>
            <h2>{movie.title}</h2>
            <img src={movie.mainImg} alt="movie" />
          </HeadLine>
          <Reviews>
            {movie.awards.map((award) => (
              <Review title={award.title} description={award.description} />
            ))}
          </Reviews>
          <ImageDisplay>
            <img src={movie.secondaryImg} alt="movie" />
          </ImageDisplay>
        </Details>
      )}
    </>
  );
};

const Details = styled(motion.div)`
  color: White;
`;

const HeadLine = styled.div`
  min-height: 90vh;
  padding-top: 20vh;
  position: relative;
  h2 {
    position: absolute;
    top: 10%;
    left: 50%;
    transform: translate(-50%, -10%);
  }
  img {
    width: 100%;
    height: 80vh;
    object-fit: cover;
  }
`;

const Reviews = styled.div`
  min-height: 70vh;
  display: flex;
  margin: 5rem 10rem;
  align-items: center;
  justify-content: space-around;
`;

const ReviewStyle = styled.div`
  padding: 5rem;
  h3 {
    font-size: 1.2rem;
  }
  p {
    font-size: 0.9rem;
    padding-top: 1rem 0rem;
  }
  .line {
    width: 100%;
    background: #23d997;
    height: 0.2rem;
    margin: 1rem 0rem;
  }
`;

const ImageDisplay = styled.div`
  min-height: 50vh;
  img {
    width: 100%;
    height: 90vh;
    object-fit: cover;
  }
`;

//Review Component
const Review = ({ title, description }) => {
  return (
    <ReviewStyle>
      <h3>{title}</h3>
      <div className="line"></div>
      <p>{description}</p>
    </ReviewStyle>
  );
};

export default MovieDetail;
